import { render, staticRenderFns } from "./ScorerTableNew.vue?vue&type=template&id=70c35176&scoped=true&"
import script from "./ScorerTableNew.vue?vue&type=script&lang=js&"
export * from "./ScorerTableNew.vue?vue&type=script&lang=js&"
import style0 from "./ScorerTableNew.vue?vue&type=style&index=0&id=70c35176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c35176",
  null
  
)

export default component.exports